export default __webpack_public_path__ + "static/media/TITULOS_10.2a79814d.png";